// La frase con la que se le pide un prompt a la IA, y la instrucción para fijarla en un Proyecto.
// Única fuente: la usan la fila de la galería, el editor (vista previa) y la banda «Usa tu IA».
// El texto es de producto (español neutro): no lo traduce i18n porque es lo que el usuario pega en su IA.
//
// Con `client` ({id, name}) el pedido fija el cliente por id: un prompt de toda la agencia pedido sin
// cliente le llega a la IA con «{cliente}» sin completar, y en un chat nuevo no tiene de dónde sacarlo.
// El id es lo que usan las herramientas (el nombre solo obliga a resolverlo, y no desambigua
// homónimos); el formato es el del prompt de una alerta (`_with_client_pinned` del Backend). El
// nombre del prompt va PRIMERO entre «»: la búsqueda del Backend usa sólo ese par.
export function promptAskPhrase(title, client = null) {
    const phrase = `Usa el prompt «${String(title || '').trim()}» de Dashbo`;
    const clientId = client ? client.id : null;
    if (clientId === null || clientId === undefined || clientId === '') return phrase;
    const clientName = String(client.name || '').trim();
    return clientName
        ? `${phrase} para el cliente «${clientName}» (client_id=${clientId})`
        : `${phrase} para el cliente con client_id=${clientId}`;
}

export const PROJECT_INSTRUCTION =
    'Cuando te pida un prompt por su nombre, o un análisis que mi agencia tiene preparado, ' +
    'búscalo primero en Dashbo con dashbo_list_prompts (pasa el nombre en search), ' +
    'prefiere los de mi agencia sobre los de Dashbo y ejecútalo con dashbo_get_prompt. ' +
    'Si el pedido trae un client_id, pásalo a dashbo_get_prompt (a la búsqueda no); si el prompt ' +
    'es para un cliente y no sabes cuál, pregúntamelo. Si hay dos parecidos, pregúntame cuál. ' +
    'Dime en una línea qué prompt usaste.';
